import { Location } from 'src/app/model/location';
import { BankPayment } from '../../Collection/bank-payment';
import { CardPayment } from '../../Collection/card-payment';
import { CashPayment } from '../../Collection/cash-payment';
import { PaytmPayment } from '../../Collection/paytm-payment';
import { UpiPayment } from '../../Collection/upi-payment';
import { ProductDetails } from '../../FacilityManager/product-details';
import { MakeToOrder } from '../../MakeToOrder/CreateOrder/make-to-order';
import { Customer } from 'src/app/model/Sale/pos/customer';
import { ServiceMan } from '../../Master/ServiceMan/service-man';
import { User } from '../../user';
import { Cart } from '../cart';
import { CouponPayment } from '../../Collection/coupon-payment';
import { WalletPayment } from '../../Collection/wallet-payment';
import { SwipePayment } from '../../Collection/swipe-payment';
import { GatewayPayment } from '../../Collection/gateway-payment';

export class GstSaleInvCumBos {
    locationCode: number;
    byUserCode: string
    timeStamp: string
    location: Location
    invoiceNo: string
    cartNo: string
    invoiceDate: string
    invoiceTime: string
    billType: string
    customerCode: string
    status: string
    notes: string
    baseAmt: number
    discAmt: number
    taxableValue: number
    cgstAmt: number
    sgstAmt: number
    igstAmt: number
    ugstAmt: number
    cessAmt: number
    invoiceType: string
    netAmt: number

    roundedOffAmount: number;
    netAmountBeforeRoundedOff: number;

    user: User
    customer: Customer
    cart: Cart
    details: ProductDetails[];
    returnedProductDetails?: any;

    servedbyCode: number;

    // for payment
    cashpayment?: CashPayment;
    upipayment?: UpiPayment;
    cardpayment?: CardPayment;
    paytmPayment: PaytmPayment;
    couponpayment?: CouponPayment;
    bankpayment?: BankPayment;
    totalPaid: number;
    walletPayment?: WalletPayment;
    swipePayment?: SwipePayment;
    gatewayPayment?: GatewayPayment;

    payments: any;

    //added for managebills
    invoiceStatus: string;
    balance: number;
    referenceDocNo: string;
    serviceMan: ServiceMan;
    makeToOrderNo?: string;
    makeToOrder: MakeToOrder;
    deliveryAddressRefNo?: string;
    totalQty?: number;

    walkInOrDelivery?: boolean;
    transactionSummaryCode?: string;
}
